import { request } from '@/shared/api/request'

export const sendFeedbackToEmail = (form, captcha) => {
	return request({ url: `/notification/email/feedback?ignoreCaptcha=false&captcha=${captcha}`, method: 'POST', headers: { 'Content-type': 'multipart/form-data' }, data: form })
}